import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Row from '../../Row';
import Popup from '../PopupOverlay';
import { useApp } from '../../../contexts/AppContext';
import { isChestEvent } from '../../../lib/events';
import WebApp from '@twa-dev/sdk';

const Header = styled.div`
  text-align: center;
  font-size: 42px;
  font-weight: 500;
  margin: 25px 0 70px;
  font-family: 'Krungthep';
  color: #efff00;
  width: 600px;
  margin: 0 auto;
`;

const Text = styled.div`
  color: #fff;
  text-align: center;
  font-size: 36px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
`;

const Chest = () => {
  const { event } = useApp();
  if (!isChestEvent(event)) throw new Error('Should not happen');

  const onConfirm = async () => {
    localStorage.setItem('welcome', 'OFF');
  };

  return (
    <Popup close="Interesting!" onConfirm={onConfirm}>
      <Row>
        <img
          alt="meerkat"
          src="/img/Meerkat.png"
          style={{
            width: '800px',
            marginTop: '-500px',
            marginBottom: '50px',
          }}
        />
      </Row>
      <Header>WORRIED MEERKATS GAME</Header>
      <Row margin="20px 0 70px">
        <Text>
          In Worried Meerkats, you can farm meerkat points, use boosts like calm, speed, and cloud, and complete
          missions for extra rewards. Strategize your gameplay, compete with other players, and earn exciting token
          drops. Dive into the fun and climb the leaderboards in this thrilling adventure!
        </Text>
      </Row>
    </Popup>
  );
};

export default Chest;
